import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import { getDecryptedAccessToken, getDecryptedData } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";

const ZoomMeeting = () => {
  const loggedInUser = getDecryptedData();
  const { meetid, pass } = useParams();
  const [errorMessage, setErrorMessage] = useState("");
    const accessToken = getDecryptedAccessToken();
  
  console.log("loggedInUser",loggedInUser)
  console.log("meetid",meetid)
  console.log("pass",pass)

  const joinMeeting = async (meetingNumber, userName, passWord) => {
    try {
      const { ZoomMtg } = await import("@zoom/meetingsdk");

      ZoomMtg.setZoomJSLib("https://source.zoom.us/3.13.1/lib", "/av");
      ZoomMtg.preLoadWasm();
      ZoomMtg.prepareWebSDK();

      const role = loggedInUser.user_type === 'patient' ? "patient" : "provider"; // attendee
      const payload = {
        meetingNumber,
        role,
        userName,
        userEmail: "",
        passWord,
        leaveUrl: "http://localhost:3000/",
      };

      // API call using axios
      // const res = await axios.get(
      //   `https://luddybuddy.com/backend/api/zoom/signature/?meetingNumber=${payload.meetingNumber}&role=1`,
      // );
      const res = await ApiServices.get(
        `/apis/default/api/zoomsignature?meetingNumber=${payload.meetingNumber}&user_type=${role}`,
         { Authorization: `Bearer ${accessToken}` }
      );
      console.log("signature Response",res.data.signature)
      const data = res.data;
      ZoomMtg.init({
        leaveUrl: payload.leaveUrl,
        success: () => {
          ZoomMtg.join({
            sdkKey: data.sdkKey,
            signature: data.signature,
            meetingNumber: payload.meetingNumber,
            userName: payload.userName,
            userEmail: payload.userEmail,
            passWord: payload.passWord,
            success: () => {
              console.log("-- Joined Zoom Meeting --");
            },
            error: (error) => {
              console.error("Zoom Join Error", error);
              setErrorMessage("Error joining the meeting.");
            },
          });
        },
        error: (error) => {
          console.error("Zoom Init Error", error);
          setErrorMessage("Error initializing Zoom SDK.");
        },
      });
    } catch (error) {
      console.error("Unexpected Error:", error);
      setErrorMessage("An unexpected error occurred.");
    }
  };

  useEffect(() => {
    if (loggedInUser && meetid && pass) {
      const userName = `${loggedInUser.fname} ${loggedInUser.lname}`;
      joinMeeting(meetid, userName, pass);
    } else {
      setErrorMessage("Meeting is invalid. Please contact your teacher.");
    }
  }, [loggedInUser, meetid, pass]);

  return (
    <div>
      <h1>Zoom Meeting</h1>
      {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
    </div>
  );
};

export default ZoomMeeting;
